export const backend = "https://kiedysmieci-0a86ef9a20ae.herokuapp.com"
export const EMAIL_SERVICE_ID = "service_in4b1rl"
export const EMAIL_TEMPLATE_ID = "template_ks0qryl"
export const EMAIL_PUBLIC = "eoShNWp2J9Yqks5eW"